<template>
  <v-card flat>
    <v-container>
      <v-row dense no-gutters class="mb-2 mx-2">
        <v-col cols="12" md="4" class="text-center">
          <label class="title">{{ t("topLogo.label") }}</label>
          <v-col cols="12">
            <InputFile
              key-name="headerLogo"
              ref="input-1"
              v-model="headerLogo"
              height="auto"
              :url-image.sync="urlHeader"
              :max-image-height="350"
              :max-image-width="1024"
              :messages="t('topLogo.message')"
            />
          </v-col>
        </v-col>
        <v-col cols="12" md="4" class="text-center">
          <label class="title">{{ t("bottomLogo.label") }}</label>
          <v-col cols="12">
            <InputFile
              key-name="footerLogo"
              ref="input-2"
              v-model="footerLogo"
              height="auto"
              :url-image.sync="urlFooter"
              :max-image-height="350"
              :max-image-width="1024"
              :messages="t('bottomLogo.message')"
            />
          </v-col>
        </v-col>
        <v-col cols="12" md="4" class="text-center">
          <label class="title">{{ t("mainBanner.label") }}</label>
          <v-col cols="12">
            <InputFile
              key-name="homeBanner"
              ref="input-3"
              v-model="homeBanner"
              :url-image.sync="urlHomeBanner"
              :max-image-height="480"
              :max-image-width="1920"
              :messages="t('mainBanner.message')"
            />
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import InputFile from "@/components/InputFile";
import { mapFields } from "vuex-map-fields";
export default {
  props: {
    value: String,
  },

  components: {
    InputFile,
  },
  computed: {
    ...mapFields("designer", [
      "model.headerLogo",
      "model.footerLogo",
      "model.homeBanner",
    ]),
    ...mapFields("designer", {
      urlHeader: "model.settings.headerLogo",
      urlFooter: "model.settings.footerLogo",
      urlHomeBanner: "model.settings.homeBanner",
    }),
  },
  methods: {
    t(key, options = {}) {
      return this.$t(`designer.images.${key}`, options);
    },
    validate() {
      //Funcion para validar si existe o no imagenes
      /* const inputs = ["input-1", "input-2", "input-3"];
      let validateStatus = true;
      inputs.forEach((input) => {
        if (!this.$refs[input].validate()) validateStatus = false;
      }); */
      return true;
    },
  },
};
</script>

<style></style>
